// extracted by mini-css-extract-plugin
export default {"actionsGap":"Bf","rightAlignedActions":"Cf","evenWidthActions":"Df","spaced":"Ef","floatingActions":"Ff","centered":"Gf","pageFiltersMargin":"Hf","pageFilters":"If"};